import BaseModel from "lib/model";
import BaseCollection from "lib/collection";

const DeliveryWindow = BaseModel.extend({
    props: {
        display_name: { type: "string", required: true },
        start: { type: "utcDate", required: true },
        end: { type: "utcDate", required: true },
        prebook: { type: "boolean", required: true, default: true },
        adjustable_dates: { type: "boolean", required: true, default: true },
        earliest_available_date: { type: "utcDate" },
        latest_available_date: { type: "utcDate" },
    },
});

const DeliveryWindows = BaseCollection.extend({
    model: DeliveryWindow,
    getImmediateWindow: function () {
        return this.models.find((model) => {
            return model.adjustable_dates && !model.prebook;
        });
    },
    getPreBookWindow: function () {
        return this.models.find((model) => {
            return model.adjustable_dates && model.prebook;
        });
    },
});

export default BaseModel.extend({
    props: {
        _id: "objectId",
        warehouse: { type: "objectId" },
        earliest_available_date: { type: "utcDate", required: true },
        latest_available_date: { type: "utcDate" },
        minimum_delivery_window: {
            type: "number",
            required: true,
            default: 1,
            test: function (value) {
                if (value < 0) {
                    return "Minimum delivery window must be a positive number";
                }
                return false;
            },
        },
        default_delivery_window: {
            type: "number",
            required: true,
            default: 1,
            test: function (value) {
                if (value < 0) {
                    return "Default delivery window must be a positive number";
                }
                return false;
            },
        },
    },

    collections: {
        delivery_windows: DeliveryWindows,
    },

    url() {
        if (this.parent.id && this.parent.collection.parent._id) {
            return `/api/v3.0/item/${this.parent.collection.parent._id}/warehouse/${this.parent.id}/availability`;
        } else if (this.parent.itemId && this.parent.code === "__none") {
            // no warehouse
            return `/api/v3.0/item/${this.parent.itemId}/availability`;
        }
        throw Error("Must have parent id");
    },
});
